import btnStyle from '../../core/elements/buttons.less';
import * as classNames from 'classnames';
import { DataService } from '../../services/data_service';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import formStyle from '../../core/forms/style/WForm.less';
import { IDs } from '../../helpers/IDs';
import { LastgangKonfiguration } from './elemente/LastgangKonfiguration';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';
import { ZusatztoolsLastgaengeDarstellung } from './ZusatztoolsLastgaengeDarstellung';

export interface ZusatztoolsLastgaengeTabelleProps {
    data: any;
    standortSelected: any;
}

export interface ZusatztoolsLastgaengeTabelleState {
    archivTid: number;
    config: any;
    dataLoaded: string;
    lastgangSelected: any;
    showDialogKonfiguration: boolean;
    formTitle: string;
}

export class ZusatztoolsLastgaengeTabelle extends React.Component<ZusatztoolsLastgaengeTabelleProps, ZusatztoolsLastgaengeTabelleState> {

    constructor(props: any) {
        super(props);
        this.state = {
            archivTid: null,
            config: null,
            dataLoaded: null,
            lastgangSelected: undefined,
            showDialogKonfiguration: false,
            formTitle: null
        };
        this.onAfterAction = this.onAfterAction.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.onFormSave = this.onFormSave.bind(this);
        this.preFilter = this.preFilter.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    getCustomActions(): Array<any> {
        return [
            {
                id: 'show',
                label: 'Lastgang anzeigen',
                key: 'show',
                func: (row: any) => {
                    if ((+row.datei || 0) > 0) {
                        if (row.konfiguration || null) {
                            this.setState({ lastgangSelected: row });
                        } else {
                            alert('Es wurde keine Konfiguration zur Darstellung der Daten gefunden!');
                        }
                    } else {
                        alert('Es wurden keine Daten gefunden!');
                    }
                },
                styleFunc: (row: any) => ((+row.datei || 0) < 1 || !(row.konfiguration || null))
                    ? { backgroundColor: 'lightgray', cursor: 'not-allowed' }
                    : {},
                info: 'Ansicht Lastgangauswertung'
            }
        ];
    }

    getExtraFormElements(): any {
        return {
            datei:
                <div className={formStyle.fieldBox}>
                    <button
                        className={classNames(btnStyle.textButton, btnStyle.config)}
                        style={{
                            backgroundPosition: '5px center', margin: 0, paddingRight: 5, paddingLeft: 25,
                            ...(!this.state.dataLoaded && !this.state.archivTid
                                ? { backgroundColor: 'lightgray', cursor: 'not-allowed' }
                                : {}
                            )
                        }}
                        disabled={!this.state.dataLoaded && !this.state.archivTid}
                        onClick={() => this.setState({ showDialogKonfiguration: true })}
                    >
                        Konfiguration
                    </button>
                </div>
        };
    }

    getFileData(tid: number): void {
        this.dataService.loadDataForModul(
            IDs.ENT_ARCHIV_ITEMS,
            { tid },
            { resolve: true, fieldList: 'name, file' },
            'wips',
            (result: any) => {
                if ((result[IDs.ENT_ARCHIV_ITEMS] || []).length) {
                    let fileName: string = result[IDs.ENT_ARCHIV_ITEMS][0].file || '';

                    if (fileName.substr(0, 11) === 'wips3_2013/') {
                        fileName = fileName.substr(11);
                    }
                    this.dataService.loadRessource(fileName, 'archiv', (b64: string) =>
                        this.setState({ dataLoaded: Base64.atob(b64) })
                    );
                } else {
                }
            }
        );
    }

    onAfterAction(action: string, data?: any): void {
        if (action === 'openFormEdit' && (+(data || {}).datei > 0)) {
            this.setState({ archivTid: data.datei, config: data.konfiguration, formTitle: data.name || null });
        } else if (['closeFormAdd', 'closeFormEdit'].indexOf(action) !== -1) {
            this.setState({ archivTid: null, config: null, dataLoaded: null, formTitle: null });
        }
    }

    onFormChange(WFormData: any): void {
        const datei: number = +WFormData.getValue('datei') || null;
        const isDeleted: boolean = !!WFormData.getValue('datei_archiv_delete');
        const rawdata: string = WFormData.getValue('datei_archiv_rawdata') || null;
        const name: string = WFormData.getValue('name') || null;
        // console.log('onFormChange: ', WFormData);
        if (rawdata && (Base64.atob(rawdata) !== this.state.dataLoaded)) {
            this.setState({ config: null, dataLoaded: Base64.atob(rawdata), showDialogKonfiguration: true });
        } else if ((!rawdata && this.state.dataLoaded && !datei) || isDeleted) {
            this.setState({ archivTid: null, config: null, dataLoaded: null });
        } else if (name !== this.state.formTitle) {
            this.setState({ formTitle: name });
        }
    }

    onFormSave(data: any, callback: () => void): void {
        if (this.state.config && typeof this.state.config === 'object') {
            try {
                data.konfiguration = JSON.stringify(this.state.config);
            } catch (error) {
                console.log(error.message);
            }
        }
        callback();
    }

    preFilter(data: Array<any>): Array<any> {
        const { standortSelected } = this.props;

        return standortSelected
            ? data.filter((item: any) => (item.standort_tid_orig || null) === standortSelected.tid)
            : data;
    }

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_LASTGANG}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    extraFormElementAfter={this.getExtraFormElements()}
                    customClass='Custom-ETA'
                    formLayout='flowV2'
                    formLayout2='noneAutoSave'
                    addLabel='Lastgang erfassen'
                    formPreset={{ standort_tid: (this.props.standortSelected || {}).tid || 0 }}
                    customActions={this.getCustomActions()}
                    actionsBtnReihenfolg={['show', 'edit', 'delete']}
                    preFilterFunction={this.preFilter}
                    onFormChange={this.onFormChange}
                    callBeforeOnFormSave={this.onFormSave}
                    onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_LASTGANG)}
                    onAfterAction={this.onAfterAction}
                />
                {this.state.lastgangSelected &&
                    <DialogWrapper2
                        onAfterClose={() => this.setState({ lastgangSelected: undefined })}
                        title={`${this.state.lastgangSelected.standort_tid || 'Lastgang'}: ${this.state.lastgangSelected.name || ''}`}
                        width={document.documentElement.clientWidth > 1280 ? document.documentElement.clientWidth - 12 : 1280}
                        left={0}
                    >
                        <ZusatztoolsLastgaengeDarstellung
                            data={this.props.data}
                            lastgangSelected={this.state.lastgangSelected}
                        />
                    </DialogWrapper2>
                }
                {this.state.showDialogKonfiguration &&
                    <DialogWrapper2
                        title={`Lastgang: ${this.state.formTitle}`}
                        width={-1}
                        onAfterClose={() => this.setState({ showDialogKonfiguration: false })}
                    >
                        <LastgangKonfiguration
                            archivTid={this.state.archivTid}
                            config={this.state.config}
                            data={this.state.dataLoaded}
                            dataGlobal={this.props.data}
                            onChange={(config: any) => this.setState({ config, showDialogKonfiguration: false })}
                            onClose={() => this.setState({ showDialogKonfiguration: false })}
                            onDataLoaded={(data: string) =>
                                this.setState(
                                    { dataLoaded: data, showDialogKonfiguration: null },
                                    () => this.setState({ showDialogKonfiguration: true })
                                )
                            }
                        />
                    </DialogWrapper2>
                }
            </div>
        );
    }
}
